import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { useTitle } from 'react-use';

import { openSidebar } from '@/redux/sidebar/actions';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

import { ResizableCollections } from '../components/ResizableCollections';

export const CollectionsPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  useTitle(t('pages.collections_simple'));

  useSegments(PageName.COLLECTIONS);

  // Handle action query parameter to open create sidebar, carrying an optional
  // prefill name (e.g. from the command palette). openSidebar sets content + meta
  // atomically so the name survives (setSidebarContent would wipe meta).
  useEffect(() => {
    if (searchParams.get('action') === 'create') {
      const name = searchParams.get('name')?.trim();
      dispatch(
        openSidebar({
          content: 'create_collection',
          meta: name ? { defaultName: name } : undefined,
        })
      );
      // Mutate a copy, not the router's live params, to avoid desyncing from it.
      const next = new URLSearchParams(searchParams);
      next.delete('action');
      next.delete('name');
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams, dispatch]);

  return <ResizableCollections />;
};
